import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import usePageTitle from 'hooks/usePageTitle';

import { UserContext } from "../../../contexts/UserContext";

const View404 = () => {
  usePageTitle('Página no encontrada');
  // importar el userData y en función del rol redirigir a una home o a otra
 
    // return <Navigate to="/login" replace />ojo login
    return (
      <section className="container">
        <div className="row">
          <div className="col-12" style={{ textAlign: 'center', padding: '60px 0' }}>
            <h1>Página no encontrada</h1>
            <p style={{ color: '#636363', margin: '16px 0 32px' }}>La ruta que buscas no existe o ha cambiado.</p>
            <a href="/inicio" className="btn-box btn-accent" style={{ display: 'inline-block' }}>Volver al inicio</a>
          </div>
        </div>
      </section>
    );
  
};

export default View404;
